export const IsQuestionEditable = (
  isOwner,
  editMCQ,
  editFRQ,
  editCbProvidedQuestion,
) => {
  return isOwner ? editMCQ || editFRQ : editCbProvidedQuestion && editMCQ;
};
